import { mockContactMethods } from "./contactMethods";

export default function accountGet(config: any) {
  console.log("MOCK: accountGet", config.url);

  let match = config.url && /\/(\w+?)$/.exec(config.url);
  const account_number = match && match[1];

  return [
    200,
    {
      id: 1,
      account: Number(account_number),
      parent_account: null,
      variables: [{ type: "label", value: "Sample Home" }],
      contact_methods: mockContactMethods,
      preferences: [
        {
          type: "bill",
          subType: "eBill",
          contact_methods: [1],
          variables: [
            { type: "DND_StartTime", value: "18:00:00" },
            { type: "DND_EndTime", value: "06:00:00" },
          ],
        },
        {
          type: "usage",
          subType: "electric_cost",
          contact_methods: [1, 2],
          variables: [
            { type: "DND_StartTime", value: "18:00:00" },
            { type: "DND_EndTime", value: "09:00:00" },
            { type: "threshold", value: "40.00" },
          ],
        },
        {
          type: "usage",
          subType: "electric_volume",
          contact_methods: [1, 2],
          variables: [
            { type: "DND_StartTime", value: "18:00:00" },
            { type: "DND_EndTime", value: "09:00:00" },
            { type: "threshold", value: "100" },
          ],
        },
      ],
    },
  ];
}
